import { constantRoutes } from '@/router'

/**
 * 过滤权限菜单
 * @param permissionsList 接口返回的权限菜单
 */
export function filterAsyncRoutes(routeList) {
  const res = []
  routeList.forEach((route) => {
    // 创建菜单
    const tmp = createRoute(route)
    if (tmp != null) {
      if (route.children) {
        tmp.children = filterAsyncRoutes(route.children)
      }
      res.push(tmp)
    }
  })
  return res
}

export function getPermission(routeList) {
  const res = []
  routeList.forEach((route) => {
    // 获取权限
    if (route.permission != null) {
      res.push(route.permission)
    }
    if (route.children) {
      res.push(...getPermission(route.children))
    }
  })

  return res
}

/**
 * 创建动态路由菜单
 * @param {*} route
 */
export function createRoute(item) {
  if (
    item.component == null ||
    undefined == item.component ||
    item.component == ''
  ) {
    return null
  }
  const temp = {
    path: item.path,
    component:
      item.parentId == 0 ? () => import('@/layout') : loadView(item.component),
    name: item.name,
    hidden: item.hidden,
    meta: {
      title: item.name,
      permission: item.permission,
      requireAuth: true,
      icon: item.icon,
      keepAlive: item.keepAlive,
      childRoute: item.childRoute
    }
  }
  return temp
}
// 静态路由懒加载
export const loadView = (view) => {
  var page = null
  try {
    page = (resolve) => require([`@/views/${view}.vue`], resolve)
  } catch (err) {
    console.error('路由加载错误', err)
  }
  return page
}

const state = {
  routes: [],
  addRoutes: [],
  permission: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_PERMISSION: (state, permission) => {
    state.permission = permission
  }
}

const actions = {
  /**
   * 筛选用户菜单
   */
  generateRoutes({ commit }, permissionsList) {
    return new Promise((resolve) => {
      // 递归遍历菜单
      const accessedRoutes = filterAsyncRoutes(permissionsList)

      // console.log(accessedRoutes)
      commit('SET_ROUTES', accessedRoutes)

      const permission = Array.from(
        new Set([...getPermission(permissionsList)])
      )

      commit('SET_PERMISSION', permission)

      resolve(accessedRoutes)
    })
  },

  setRoutes({ commit }, routes) {
    return new Promise((resolve) => {
      commit('SET_ROUTES', routes)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
